<div class="generic-modal-root">

  <div class="row-padding">
    <div class="row">
      <label style="width: 100%; height: 200px;" #dropZone for="file-1">
        <input
          type="file"
          (change)="uploadAndClose($event.target.files)"
          name="file-1[]"

          id="file-1"
          class="inputfile inputfile-3"
          data-multiple-caption="{count} files selected"
          accept="image/x-png,image/gif,image/jpeg" />
    </label>
    <span style="color: lightgray; pointer-events: none;
    font-size: 200px;
    position: absolute;
    left: 30%;
    bottom: 2%;">+</span>
    <span style="color: lightgray; pointer-events: none;
    position: absolute;
    left: 26%;
    bottom: 20%;">Drop Images or Click Here</span>
    </div>
  </div>
</div>
